/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseCityModel>>;
export function request(
  body: defs.basics.BaseCityRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCity/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
